<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">{{ getPatternName() }}</span>
            </template>
            <template #left>
                <van-icon name="arrow-left" color="#ffffff"/>
                <span style="color: #ffffff" @click="toBack">返回</span>
            </template>
        </van-nav-bar>
        <van-cell style="background-color: #a9e38e;font-size: 0.6rem;padding: 0px 10px">
            <van-row type="flex" justify="space-between">
                <van-col span="16">当前科目:{{ undefined === learn.subject ? "" : learn.subject.name }}</van-col>
                <van-col span="4">共{{ undefined === topics ? "" : topics.length }}题</van-col>
            </van-row>
        </van-cell>

        <div v-if="!showExamScore">

            <div style="padding: 10px 15px;font-size: 1.4rem;">
                <van-empty v-if="null === topic || topics.length <= 0" description="暂无试题"/>
                <div v-else>
                    {{ topicIndex + 1 }}、
                    <van-tag type="warning">{{ getTopicTypeName(topic.type) }}</van-tag>
                    {{ topic.content }}
                    <br><br>
                    <van-checkbox-group v-if="3===topic.type" v-model="answers">
                        <van-checkbox style="min-height: 60px;"
                                      v-for="(item,index) in topic.options"
                                      :key="item.id"
                                      @click="chooseAnswer"
                                      :name="index">
                            <span>{{ getAbcText(item) }}</span>
                            {{ item.content }}
                        </van-checkbox>
                    </van-checkbox-group>

                    <van-radio-group v-else v-model="answer">
                        <van-radio style="min-height: 60px;"
                                   v-for="(item,index) in topic.options"
                                   :key="item.id"
                                   @click="chooseAnswer"
                                   :name="index">
                            <span>{{ getAbcText(item) }}</span>
                            {{ item.content }}
                        </van-radio>
                    </van-radio-group>


                </div>
                <div v-if="5!==pattern && topics.length>0 && false===isReadTopic && 6!==pattern" style="padding: 10px">

                    <van-row>
                        <van-col span="8">
                            <van-button v-if="false == showAnswer" size="small" type="info"
                                        @click="showAnswer=!showAnswer">显示答案
                            </van-button>
                            <van-button v-else size="small" type="info" plain @click="showAnswer=!showAnswer">隐藏答案
                            </van-button>
                        </van-col>
                        <van-col span="6">
                            <div style="border-bottom:1px solid #000;text-align: center" v-if="showAnswer">
                                {{ topic.answer }}
                            </div>
                        </van-col>

                        <van-col v-show="undefined !== topic && topic.analysis" span="8">
                            <van-button v-if="false === showAnalysis"
                                        type="primary"
                                        size="small"
                                        @click="showAnalysis=!showAnalysis">参考解析
                            </van-button>
                            <van-button v-else size="small" type="primary" plain @click="showAnalysis=!showAnalysis">
                                隐藏解析
                            </van-button>
                        </van-col>
                    </van-row>
                    <van-row>

                        <van-col span="24">
                            <div v-if="showAnalysis">
                                <br>
                                {{ topic.analysis }}
                            </div>
                        </van-col>

                    </van-row>


                </div>

                <div v-if="6===pattern || true === isReadTopic" style="padding: 10px">
                    <van-row>
                        <span v-if="6===pattern" v-html="checkTopicIsTrueString(topic)"></span>
                    </van-row>
                    <van-row>
                        <van-col span="8">
                            <van-button size="small" type="info">正确答案:</van-button>
                        </van-col>
                        <van-col span="6">
                            <div style="border-bottom:1px solid #000;text-align: center">
                                {{ !topic ? "" : topic.answer }}
                            </div>
                        </van-col>
                    </van-row>

                    <van-row style="font-size: 0.3em" type="flex" justify="end">
                        <van-col span="8" @click="feedback">
                            题目有错
                            <van-icon name="question" color="#4089f2"></van-icon>
                            点击反馈
                        </van-col>

                    </van-row>
                </div>
            </div>
            <br>
            <van-tabbar route>
                <van-tabbar-item style="font-size: 1rem;font-weight: bold" v-if="5===pattern" @click="endExam">
                    <van-count-down
                            ref="examCountDown"
                            :auto-start="false"
                            @finish="endExam"
                            :time="examTime">
                        <template v-slot="timeData">
                            <span style="color: #ff0000" class="item">{{ timeData.minutes }}:</span>
                            <span style="color: #ff0000" class="item">{{ timeData.seconds }}</span>
                            <br>
                            <span>交&nbsp;&nbsp;&nbsp;&nbsp;卷</span>
                        </template>
                    </van-count-down>
                </van-tabbar-item>
                <van-tabbar-item icon="arrow-up" @click="upTopic">上一题</van-tabbar-item>

                <van-tabbar-item v-if="1===pattern" icon="notes-o" @click="changeTopicTypeModel=true">换题型
                </van-tabbar-item>

                <van-tabbar-item v-if="2===pattern" icon="notes-o" @click="isReadTopic=!isReadTopic">读题
                </van-tabbar-item>

                <van-tabbar-item v-if="3===pattern" icon="notes-o" @click="deleteCuoTopic">删此题</van-tabbar-item>

                <van-tabbar-item icon="expand-o" @click="changeTopicNumberModel=true">换题号</van-tabbar-item>

                <van-tabbar-item icon="arrow-down" @click="downTopic">下一题</van-tabbar-item>
            </van-tabbar>

        </div>

        <div style="margin: 0 20px" v-else>

            <br>
            <van-row type="flex" justify="center">
                <van-circle v-model="zon_score" :rate="all_score" layer-color="#ebedf0">
                    <template #default>
                        <div class="van-circle__text">
                            <span style="font-size: 25px">{{ all_score }}分</span>
                            <br>继续努力
                        </div>
                    </template>
                </van-circle>

            </van-row>
            <br>
            <van-row>
                提示，如果低于及格分，建议点击"原题再来"过关为止，这样训练效果更好。
            </van-row>
            <van-divider/>

            <!--            <van-row>-->
            <!--                <van-col span="10">用时:1分钟</van-col>-->
            <!--            </van-row>-->

            <van-row>
                <van-col span="8">单选题:{{ dan_score }}分</van-col>
                <van-col span="8">判断题:{{ pan_score }}分</van-col>
                <van-col span="8">多选题:{{ duo_score }}分</van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" justify="center">
                <van-col span="12">
                    <van-button type="primary" to="/" block>返回主界面</van-button>
                </van-col>

            </van-row>
            <br>
            <van-row type="flex" justify="center" gutter="20">
                <van-col span="12">
                    <van-button plain type="primary" @click="examAgain" block>原题再来</van-button>
                </van-col>
                <van-col span="12">
                    <van-button plain type="primary" url="/exercise?pattern=3" block>错题练习</van-button>
                </van-col>
            </van-row>
            <br>

            <van-row type="flex" justify="center" gutter="20">
                <van-col span="12">
                    <van-button plain type="primary" @click="toFuJuan" block>复&nbsp;&nbsp;卷</van-button>
                </van-col>
                <van-col span="12">
                    <van-button plain type="primary" url="/exercise?pattern=5" block>重新出题</van-button>
                </van-col>
            </van-row>

        </div>

        <van-dialog v-model="changeTopicTypeModel"
                    showCancelButton
                    @confirm="changeTopicType"
                    title="请选择题型">
            <van-row style="margin: 10px 20px">
                <van-radio-group v-model="topicType">
                    <van-cell-group title="">
                        <van-cell v-for="item in getTopicSpecialOptions()" :key="item.value" :title="item.name"
                                  clickable
                                  @click="topicType = item.value">
                            <template #right-icon>
                                <van-radio :name="item.value"/>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </van-row>
        </van-dialog>

        <van-dialog v-model="changeTopicNumberModel"
                    showCancelButton
                    @confirm="changeTopicNumber"
                    :title="'题号跳转(共'+topics.length+'题)'">
            <van-row style="margin: 10px 20px">
                <van-cell-group v-if="5 != pattern && 6 != pattern">
                    <van-field label-width="130" label="请输入题号:" type="digit" v-model="topicNumber"/>
                </van-cell-group>

                <van-col v-else span="3" :border="false" v-for="(topic,index) in topics" :key="index">
                    <van-tag :type="getTopicNumberTagColor(topic)" :plain="getTopicNumberTagPlain(topic)"
                             @click="changeTopicNumber(index)">{{ index + 1 }}
                    </van-tag>
                </van-col>
            </van-row>
        </van-dialog>

        <van-dialog v-model="loadingModel" title="" :show-confirm-button="false">
            <br>
            <van-loading size="50px" vertical>{{ loadingModelText }}</van-loading>
            <br>
        </van-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {

            learn_id: 0,//学习id，复卷用

            pattern: 5,//模式:1顺序练习;2专项练习;3错题练习;5模拟考试;6复卷

            isReadTopic: false,//开启读题
            showAnswer: 0,//显示答案
            showAnalysis: false,//显示解析

            topicType: 0,//题目种类
            topicIndex: 0,//题目索引
            topicNumber: 1,//题号

            answer: 0,//单选题的答案
            answers: [],//多选题的答案

            zon_score: 100,//总分
            all_score: 0,//自己得分
            dan_score: 0,//单选题分数
            pan_score: 0,//判断题分数
            duo_score: 0,//多选题分数

            loadingModel: false,
            loadingModelText: "加载中...",


            examTime: 3600000,//考试倒计时

            showExamScore: false,//考试结果页面

            changeTopicNumberModel: false,//换题号弹出框
            changeTopicTypeModel: false,//换题型弹出框

            topic: null,//当前题目
            topics: [],//题目集合
            topics_bak: [],//题目集合，备份，方便原题重来
            learn: {},
            vip: {},

            indexDB: undefined,
            indexDBStatus: 0,//indexDB的状态,-1打开失败,0未打开,1打开成功
        }
    },
    created() {
        // this.initIndexDB()

        if (undefined === this.$route.query.pattern || "" === this.$route.query.pattern) {
            this.pattern = 1
        } else {
            this.pattern = Number(this.$route.query.pattern)
        }
        this.learn_id = undefined === this.$route.query.learn_id ? 0 : this.$route.query.learn_id
        if (2 === this.pattern) {
            this.changeTopicTypeModel = true
        } else if (6 === this.pattern) {
            //去本地存储里面获取复卷的数据
            this.getFuJuanTopics(this.learn_id)
        } else {
            this.getTopics()
        }

        //当前页面监视键盘输入
        document.onkeydown = e => {
            if ("ArrowRight" === e.key) {
                this.downTopic()
            } else if ("ArrowLeft" === e.key) {
                this.upTopic()
            }
        }
        window.onpopstate = ev => {
            console.log(ev)
        }
    },
    methods: {
        getTopics() {
            this.loadingModel = true
            this.$http.get("/wechat/exercise", {
                params: {
                    pattern: this.pattern,
                    special: this.topicType,
                    learn_id: this.learn_id
                }
            }).then(res => {
                console.log(res.data);
                this.loadingModel = false;
                if (2202 === res.data.code) {
                    this.$dialog.confirm({
                        title: '提示',
                        message: res.data.msg,
                        confirmButtonText: "知道了",
                        cancelButtonText: "去充值"
                    }).then(() => {

                    }).catch(() => {
                        this.$router.push('/buy');
                    });
                    return
                }

                if (200 !== res.data.code) {
                    return
                }
                if (6 === this.pattern) {
                    if (!this.topics) {
                        console.log("本地题库不存在，启用服务器数据")
                        this.topics = res.data.data.topics
                    }
                    if (!this.topics) {
                        this.$dialog.confirm({
                            title: '复卷失败',
                            message: '当前考试记录缓存已经被清除，或者不在本设备上!',
                            showCancelButton: false
                        }).then(() => {
                            this.$router.push('/learns');
                        });
                        return;
                    }
                } else {
                    this.topics = res.data.data.topics;
                    this.topics_bak = res.data.data.topics;
                }
                this.learn = res.data.data.learn;
                this.vip = res.data.data.vip;

                if (this.topics.length <= 0) {
                    //最终的选项了
                    return
                }
                if (5 === this.pattern) {
                    this.$refs.examCountDown.start();
                }

                //顺序联系，获取上次练题的题目
                if (1 === this.pattern) {
                    this.topicIndex = this.getLastTopicIndex(this.learn.subject.id)
                }

                if (1 === this.pattern || 2 === this.pattern) {
                    if (1 !== this.vip.exercise_status) {
                        this.$dialog.confirm({
                            title: '未充值提示',
                            message: '当前科目未充值，只能练习100道题',
                            confirmButtonText: "知道了",
                            cancelButtonText: "去充值"
                        }).then(() => {

                        }).catch(() => {
                            this.$http.get("/wechat/learn/end/" + this.learn.id).then(res => {
                                console.log(res.data);
                                this.$router.push('/buy');
                            });
                        });
                    }
                }
                this.setTopic()
            });
        },
        setTopic() {
            if (this.topicIndex < 0 || this.topicIndex > this.topics.length) {
                return
            }

            this.answer = ""
            this.answers = []
            this.showAnswer = 0

            this.topicNumber = this.topicIndex + 1
            this.topic = this.topics[this.topicIndex]

            //顺序练习，设置上次练题的题目
            if (1 === this.pattern) {
                this.setLastTopicIndex(this.learn.subject.id, this.topicIndex)
            }

            this.readTopic()
        },

        chooseAnswer() {
            window.setTimeout(this.chooseAnswerDeal, 300)
        },

        //答题
        chooseAnswerDeal() {
            //模式:1顺序练习;2专项练习;3错题练习;5模拟考试;6复卷
            if ("" === this.answer && this.answers.length <= 0) {
                return;
            }
            if (true === this.isReadTopic || 6 === this.pattern) {
                console.log("不做判断")
                //读题模式不做判断
                //复卷模式不做判断
                return;
            }

            //清除上一次选择的
            this.topics[this.topicIndex].options.forEach((item, index) => {
                this.topics[this.topicIndex].options[index].is_choose = 0
            });

            if (undefined !== this.topic && 3 === this.topic.type) {
                this.answers.forEach((item) => {
                    this.topics[this.topicIndex].options[item].is_choose = 1
                })
                //多选题，无法点击一次是判断正确，所以不再做后续判断
                return
            } else {
                this.topics[this.topicIndex].options[this.answer].is_choose = 1
            }

            var is_true = false
            if (1 === this.topic.options[this.answer].is_answer) {
                is_true = true
            }

            if (5 === this.pattern) {
                //考试模式下错题记录
                if (!is_true) {
                    this.recordCuoTopic(this.topic.id)
                }

                this.downTopic()
                return;
            }

            if (is_true) {
                this.downTopic()
            } else {
                //错题练习模式下不记录错题
                if (3 !== this.pattern) {
                    this.recordCuoTopic(this.topic.id)
                }
                this.showAnswer = true
            }

        },
        //上一题
        upTopic() {
            if (this.topicIndex <= 0) {
                this.$toast('已经是第一题了');
                return
            }
            this.topicIndex--
            this.setTopic()
        },
        //下一题
        downTopic() {
            //多选题,且在不是错题练习模式下面，这里加入一个判断是否答对的
            if (undefined !== this.topic && 3 === this.topic.type && 3 !== this.pattern) {
                if (-1 === this.checkTopicIsTrue(this.topic)) {
                    this.recordCuoTopic(this.topic.id)
                }
            }

            if (this.topicIndex >= (this.topics.length - 1)) {
                this.$toast('已经是最后一题了');
                return
            }
            this.topicIndex++
            this.setTopic()
        },
        //读题模式，设置答案
        readTopic() {
            //只有在读题模式、考试、复卷情况下才设置答案
            if (true === this.isReadTopic || this.pattern >= 5) {
                if (undefined !== this.topic && 3 === this.topic.type) {//多选题
                    this.topic.options.forEach((option, index) => {
                        if (this.pattern >= 5) {
                            if (1 === option.is_choose) {
                                this.answers.push(index)
                            }
                        } else if (true === this.isReadTopic) {
                            if (1 === option.is_answer) {
                                this.answers.push(index)
                            }
                        }
                    })
                } else {//单选题
                    this.topic.options.forEach((option, index) => {
                        if (this.pattern >= 5) {
                            if (1 === option.is_choose) {
                                this.answer = index
                            }
                        } else if (true === this.isReadTopic) {
                            if (1 === option.is_answer) {
                                this.answer = index
                            }
                        }
                    })
                }
            }
        },

        changeTopicType() {
            this.topics = []
            this.changeTopicTypeModel = false
            console.log(this.topicType)
            this.getTopics()
        },

        //换题号
        changeTopicNumber(toNumber = 0) {
            this.changeTopicNumberModel = false
            if (toNumber) {
                this.topicNumber = toNumber + 1
            }
            this.topicIndex = this.topicNumber - 1
            this.setTopic()
        },
        //记录错题
        recordCuoTopic(topic_id) {
            this.$http.post("/wechat/recode_wrong_topic", {
                action: "add",
                topic_ids: [topic_id]
            }).then(res => {
                console.log(res.data);
            });
        },
        //删错题
        deleteCuoTopic() {
            this.$http.post("/wechat/recode_wrong_topic", {
                action: "del",
                topic_ids: [this.topic.id]
            }).then(res => {
                var nowTopicIndex = this.topicIndex
                // this.topics.splice(this.topicIndex,1)
                if (this.topicIndex < (this.topics.length - 1)) {
                    this.downTopic()
                    this.topics.splice(nowTopicIndex, 1)
                    this.topicIndex = this.topicIndex - 1
                } else {
                    this.upTopic()
                    this.topics.splice(nowTopicIndex, 1)
                }
                console.log(res.data);
            });
        },


        //保存考试的试卷到本地存储
        saveLearnTopics(learn_id, topics) {
            var mydb = window.indexedDB.open("examination", 1);
            mydb.onsuccess = () => {
                this.indexDB = mydb.result;
                this.indexDBStatus = 1;
                console.log('数据库打开成功');

                var transaction = this.indexDB.transaction(['learn_topics'], 'readwrite')
                var objectStore = transaction.objectStore("learn_topics");
                objectStore.add({learn_id: learn_id, topics: JSON.stringify(topics)});

                transaction.onsuccess = (event) => {
                    console.log('数据写入成功', event);
                };

                transaction.onerror = (event) => {
                    this.$toast('保存复卷数据失败');
                    console.log('数据写入失败', event);
                    // localStorage.setItem("learn_" + learn_id, JSON.stringify(topics));
                }
            };
            mydb.onerror = (event) => {
                this.indexDBStatus = -1;
                this.$toast('init indexDB err');
                console.log("Database error: " + event.target);

                this.$toast('在保存复卷数据时，indexDB未能打开');
                // localStorage.setItem("learn_" + learn_id, JSON.stringify(topics));
            };
            mydb.onupgradeneeded = () => {
                console.log('数据库onupgradeneeded');
                this.indexDB = mydb.result;
                if (!this.indexDB.objectStoreNames.contains('learn_topics')) {
                    console.log("不存在")
                    this.indexDB.createObjectStore('learn_topics', {keyPath: "learn_id"});
                }
            }
        },
        //获得复卷的试卷
        getFuJuanTopics(learn_id) {
            this.loadingModel = true

            var mydb = window.indexedDB.open("examination", 1);

            mydb.onerror = () => {
                this.indexDBStatus = -1;
                this.$dialog.confirm({
                    title: '复卷失败',
                    message: '当前考试记录缓存已经被清除，或者不在本设备上!(indexDB open error)',
                    showCancelButton: false
                }).then(() => {
                    this.$router.push('/learns');
                });
            };
            mydb.onupgradeneeded = () => {
                console.log('数据库onupgradeneeded');
                this.indexDB = mydb.result;
                if (!this.indexDB.objectStoreNames.contains('learn_topics')) {
                    console.log("不存在")
                    this.indexDB.createObjectStore('learn_topics', {keyPath: "learn_id"});
                }
            }

            mydb.onsuccess = () => {
                this.indexDB = mydb.result;
                this.indexDBStatus = 1;
                console.log('数据库打开成功', learn_id);

                var transaction = this.indexDB.transaction(['learn_topics'])
                var objectStore = transaction.objectStore("learn_topics");
                var request = objectStore.get(parseInt(learn_id));
                request.onerror = () => {
                    // 错误处理!
                    console.log("读取失败")
                    // localStorage与indexDB过渡期，在indexDB查不到就在localStorage查一下
                    this.topics = JSON.parse(localStorage.getItem("learn_" + learn_id))
                    this.getTopics()
                };
                request.onsuccess = () => {
                    // 对 request.result 做些操作！
                    console.log("读取成功")

                    if (undefined !== request.result && undefined !== request.result.topics) {
                        this.topics = JSON.parse(request.result.topics)
                        this.getTopics()
                    } else {
                        // localStorage与indexDB过渡期，在indexDB查不到就在localStorage查一下s
                        this.topics = JSON.parse(localStorage.getItem("learn_" + learn_id))
                        this.getTopics()
                    }
                };

            };
        },

        endExam() {
            this.$toast('考试结束');
            this.getScore();

            this.saveLearnTopics(this.learn.id, this.topics);
            var answers = ""
            if (this.all_score > 10) {
                console.log("考试分数大于10分，保存复卷信息到服务器", this.all_score)
                answers = JSON.stringify(this.topics)
            }
            this.$http.post("/wechat/learn/end/" + this.learn.id, {
                score: this.all_score,
                answers: answers
            }).then(res => {
                console.log(res.data);
                // this.$router.push('/');
            });

            this.showExamScore = true;
        },
        //考试结束后的判分
        getScore() {
            this.all_score = 0;
            this.dan_score = 0;
            this.pan_score = 0;
            this.duo_score = 0;
            this.topics.forEach((topic) => {
                var is_true = this.checkTopicIsTrue(topic)
                if (is_true >= 1) {
                    this.all_score += topic.score;
                    switch (topic.type) {
                        case 1:
                            this.dan_score += topic.score
                            break;
                        case 2:
                            this.pan_score += topic.score
                            break;
                        case 3:
                            this.duo_score += topic.score
                            break;
                    }
                }
            })
            console.log(this.all_score)
        },
        //判断一道题是否答对(返回:-1错误,0未答题,1正确)
        checkTopicIsTrue(topic) {
            if (!topic) {
                return 0;
            }
            var is_true = true;
            var is_choose = false;
            topic.options.forEach((option) => {

                if (option.is_choose != option.is_answer) {
                    is_true = false;
                }
                if (1 === option.is_choose) {
                    is_choose = true;
                }
            });
            if (false === is_choose) {
                return 0;
            }
            if (is_true) {
                return 1;
            } else {
                return -1;
            }
        },
        //判断一道题是否答对
        checkTopicIsTrueString(topic) {
            if (!topic) {
                return ""
            }
            switch (this.checkTopicIsTrue(topic)) {
                case -1:
                    return ''
                // return '<span style="color: red">答错了</span>'
                case 0:
                    return "未作答"
                case 1:
                    return ''
                // return '<span style="color: green">答对了</span>'
                default:
                    return "题目存在问题"
            }
        },
        feedback() {
            var content = JSON.stringify(this.topic);
            this.$http.post("/wechat/feedback", {
                type: 1,
                content: content
            }).then(res => {
                console.log(res.data);
                this.$dialog.alert({title: "提示", message: "反馈成功"})
            });
        },

        //点击页面顶部返回时的操作
        toBack() {
            if (undefined === this.learn.id) {
                this.$router.push('/');
                return
            }
            this.$dialog.confirm({
                title: '确定要退出吗',
                message: '确定要退出吗？',
            }).then(() => {
                if (5 == this.pattern) {
                    this.getScore()
                    this.$router.push('/');
                } else {
                    this.$http.get("/wechat/learn/end/" + this.learn.id).then(res => {
                        console.log(res.data);
                        this.$router.push('/');
                    });
                }
            });
        },

        //去复卷，考试结束后使用
        toFuJuan() {
            window.location.href = '/exercise?pattern=6&learn_id=' + this.learn.id
            // this.$router.push('/exercise?pattern=6&learn_id='+this.learn.id);
        },
        //原题重来，考试结束后使用
        examAgain() {
            this.topics = this.topics_bak;
            this.topicIndex = 0;
            this.setTopic()
            this.examTime = 90 * 60 * 60;
            this.showExamScore = false;
            // this.$refs.examCountDown.reset();
            // this.$refs.examCountDown.start();
        },
        //显示选项的时候，出现abcd
        getAbcText(option) {
            if (2 === this.topic.type) {
                return ""
            }
            switch (option.sort) {
                case 0:
                    return "A、"
                case 1:
                    return "B、"
                case 2:
                    return "C、"
                case 3:
                    return "D、"
                case 4:
                    return "E、"
                case 5:
                    return "F、"
                case 6:
                    return "G、"
                case 7:
                    return "H、"
                default:
                    return ""
            }
        },
        //获取题目类型
        getTopicSpecialOptions() {
            if (2 !== this.pattern) {
                return [
                    {value: 0, name: '全部'},
                    {value: 1, name: '单选题'},
                    {value: 2, name: '判断题'},
                    {value: 3, name: '多选题'},
                ];
            } else {
                return [
                    {value: "0", name: '全部'},
                    {value: "1", name: '单选题-所有'},
                    {value: "1A", name: '单选题-A'},
                    {value: "1B", name: '单选题-B'},
                    {value: "1C", name: '单选题-C'},
                    {value: "2", name: '判断题'},
                    {value: "2正确", name: '判断题-答案为正确'},
                    {value: "2错误", name: '判断题-答案为错误'},
                    {value: "3", name: '多选题'},
                ];
            }

        },
        //获取题目类型名称
        getTopicTypeName(type) {
            switch (type) {
                case 1:
                    return '单选题';
                case 2:
                    return '判断题';
                case 3:
                    return '多选题';
                default:
                    return '未知';
            }
        },
        //获取模式名称
        getPatternName() {
            //模式:1顺序练习;2专项练习;3错题练习;5模拟考试;6复卷
            switch (this.pattern) {
                case 1:
                    return '顺序练习';
                case 2:
                    return '专项练习';
                case 3:
                    return '错题练习';
                case 5:
                    return '模拟考试';
                case 6:
                    return '复卷';
                default:
                    return '学易通';
            }
        },
        //判断一个题是否作答了
        getIsAnswer(options) {
            var is_choose = 0
            options.forEach((option) => {
                is_choose += option.is_choose
            })
            if (is_choose > 0) {
                return true
            } else {
                return false
            }
        },
        //选择题号的时候，tag的颜色
        getTopicNumberTagColor(topic) {
            var is_true = this.checkTopicIsTrue(topic)
            if (6 === this.pattern) {
                switch (is_true) {
                    case -1:
                        return "danger"
                    case 0:
                        return "default"
                    case 1:
                        return "success"
                }
            } else {
                switch (is_true) {
                    case 0:
                        return "default"
                    case -1:
                    case 1:
                        return "primary"
                }
            }
        },
        getTopicNumberTagPlain(topic) {
            var is_true = this.checkTopicIsTrue(topic)
            switch (is_true) {
                case 0:
                    return true
                case -1:
                case 1:
                    return false
            }
        },

        setLastTopicIndex(subject_id, index) {
            if (!subject_id) {
                return 0
            }
            localStorage.setItem("learn_last_topic_" + subject_id, index);
        },
        getLastTopicIndex(subject_id) {
            if (!subject_id) {
                return 0
            }
            var index = localStorage.getItem("learn_last_topic_" + subject_id)
            if (index) {
                return Number(index)
            } else {
                return 0
            }
        }

    },
    mounted() {
    }

}
</script>
